import { isNativeApp } from '@/lib/capacitor';

/**
 * Verrou d'échelle de la WebView (APK uniquement, aucun rebuild natif).
 *
 * Retour WAVE 2026-09-10 : « les articles sont en gros dans le panier ».
 * Aucune régression de code — la WebView Android autorise le zoom par
 * pincement, et un pincement accidentel sur l'écran tactile laisse toute la
 * caisse agrandie (panier, tuiles, dialogues). On fige l'échelle à 1 et on
 * interdit le pincement ; sur web (desktop/navigateur) rien ne change,
 * l'utilisateur garde son zoom navigateur.
 */

export const NATIVE_VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';

export function installNativeViewportLock(doc: Document = document): boolean {
  if (!isNativeApp()) return false;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (meta) meta.setAttribute('content', NATIVE_VIEWPORT_CONTENT);
  // Ceinture + bretelles : les gestes multi-touch de zoom ne ciblent plus la page.
  doc.documentElement.style.touchAction = 'pan-x pan-y';
  return true;
}
